import {Injectable} from '@angular/core';
import {ToastrMessagesProvider} from './toastr-messages.service';
import {ErrorMessage} from '../types/toastr-notifications.type';

@Injectable({
  providedIn: 'root',
})
export class ToastrNotificationsService {
  constructor(private toastr: ToastrMessagesProvider) {}

  private message: string;

  public notifyError({error, message = ErrorMessage.SomethingWrong}: {error: any; message?: string}): void {
    if (error?.status === 403) {
      return;
    }

    this.message = ErrorMessage[error?.status] || message;
    this.toastr.warning(this.message);
  }

  public notifySuccess(message: string): void {
    this.message = message;
    this.toastr.success(this.message);
  }

  switchToMainContainer() {
    this.toastr.switchToMainContainer();
  }
}
